import React, { useState, useContext, useEffect } from "react";
import { Utils, UserContext } from "./../../common";
import _ from "lodash";
import moment from "moment";
import axios from "axios";
import ChoosePlans from "./ChoosePlans";

import { Card, Row, Col, Modal, Button, Alert, ProgressBar, Table } from "react-bootstrap";

const PlanHeader = () => {
  const { userData, addToUserData } = useContext(UserContext);
  
  const [payments, setPayments] = useState([]);

  const [confirmCancel,setConfirmCancel] = useState(false);
  const [cancelling, setCancelling] = useState(false);
  const [choosePlan, setChoosePlan] = useState(false);

  const plan = _.get(userData,'plan',{modules: []});
  
  const modules = JSON.parse(plan.modules);

  const fetchPayments = () => {
    axios
       .get(Utils.apiUrl("payment/fetchPayments/"), Utils.apiHeaders())
       .then((res) => {
          if (res.data.success) {
            setPayments(_.get(res, "data.payments", []));
          }
        })
       .catch((err) => window.alert(err));
  };

  useEffect(fetchPayments, []);

  const goForCancellation = () => {
    setCancelling(true);
    setConfirmCancel(false);
    axios
        .delete(Utils.apiUrl("payment/cancelSubscription/"), Utils.apiHeaders())
        .then((res) => {
          if (res.data.success) {
            addToUserData({'subscription_cancelled':true});   
          } else {
            window.alert(_.isObject(res.data.message) ? Object.values(res.data.message).join(",") : res.data.message);
          }
        })
        .catch((err) => window.alert(err))
        .finally(() => setCancelling(false));
  };

  const confirmCancelBox = () => {
    return (
      <Modal show={confirmCancel} centered>
        <Modal.Header style={{ borderBottom: "0" }} className="pb-0 mb-0">
          <img
            src={`${process.env.PUBLIC_URL}/images/close.png`}
            className="ms-auto clickable"
            title="Close"
            alt="Close"
            onClick={() => setConfirmCancel(false)}
          />
        </Modal.Header>
        <Modal.Body className="bg-white text-center px-5">
          <img src={`${process.env.PUBLIC_URL}/images/alert.png`} className="mb-3" alt="Information" />
          
          <h6 className="text-danger mt-3">
            <div className="text-start my-2">
              <Alert variant="warning">Your subscription will expire on <b>{moment(userData.plan_expires).format("MMM DD, YYYY")}</b></Alert>
            You won't be able to access these essential features:
            {modules.map(mod => <div className="ms-3"><img src={`${process.env.PUBLIC_URL}/images/check.png`} width="15" className="ms-1 ps-1" /> {userData.planmods.find(pm => parseInt(pm.id)===parseInt(mod)).title}</div>)}
            </div>
            
            <h4>Are you sure you want to cancel your subscription?</h4>
            
          </h6>
          <Button variant="secondary" className="d-block mx-auto mt-4 w-100" onClick={() => setConfirmCancel(false)}>
            No, do not proceed.
          </Button>
          <Button variant="danger" className="d-block mx-auto mt-2 mb-4 w-100" onClick={goForCancellation}>
            Yes, go ahead and cancel the subscription.
          </Button>
        </Modal.Body>
      </Modal>
    );
  };

  const renderPaymentRow = (payment) => {
    let plan = JSON.parse(payment.plan);
    return <tr className="shadow dashboardStats" key={payment.id}>
      <td>{_.get(plan,'name','')}</td>
      <td>{moment(payment.active_at).format('D/M/Y')}</td>
      <td>{payment.paid_amount}</td>
      <td><a className="text-success" href={Utils.apiUrl(`payment/invoice/${payment.invoice_id}`)}>Invoice</a></td>
    </tr>;
  };

  return <Row className="mt-0 mt-sm-4">
    <Col xs="12" lg="4" className="my-1">
      <Card border="light" className="shadow dashboardStats current-plan h-100">
        <Card.Body>
          <div className="mb-3">CURRENT PLAN</div>
          <div className="title">🚀 {plan.name}</div>
          <div className="subtitle mb-3 text-center">Premium subscription plan active since: <span className="date">{moment(userData.plan_starts).format("MMM DD, YYYY")}</span></div>
          {cancelling === true && <Alert variant="danger" className="p-2 mt-2 mb-0">
              <p className="loading-msg">Cancelling Subscription</p>
              <ProgressBar variant="danger" animated now={100} />
          </Alert>}
          {cancelling===false && <div className="mt-2 text-center">
            {_.get(userData,'subscription_cancelled',false) === false && <>
              <button className="btn btn-warning me-1" onClick={() => setChoosePlan(true)}>Upgrade Plan</button>
              <button className="btn btn-danger ms-1" onClick={()=>setConfirmCancel(true)}>Cancel Plan</button>
            </>}
            {_.get(userData,'subscription_cancelled',false) === true &&  <Alert variant="light" className="p-2 mt-2 mb-0">Your subscription is not active.</Alert>}
          </div>}
          {confirmCancel && confirmCancelBox()}
        </Card.Body>
      </Card>
    </Col>
    <Col xs="12" lg="4" className="my-1">
      <Card border="light" className="shadow dashboardStats h-100 expiry-box">
        <Card.Body className="p-5">
          <div className="title">RENEWAL ON</div>
          <div className="date mb-3">{moment(userData.plan_expires).format("DD/MM/YYYY")}</div>
          
        </Card.Body>
      </Card>
    </Col>
    <Col xs="12" lg="4" className="my-1">
      <Card border="light" className="shadow dashboardStats h-100">
        <Card.Body>
          <div className="plan-features">
            <div className="title">CURRENT FEATURES</div>
            <div className="subtitle">Unlock the full potential of DentTrack with these essential features</div>
            <hr />
            <div className="d-flex flex-wrap">
              {modules.map((mod,idx) => <div className="ms-3" key={idx}><img src={`${process.env.PUBLIC_URL}/images/check.png`} width="15" className="ms-1 ps-1" /> {userData.planmods.find(pm => parseInt(pm.id)===parseInt(mod)).title}</div>)}
            </div>
          </div>
        </Card.Body>
      </Card>
    </Col>

    {choosePlan && <ChoosePlans onPayment={() => {
      setChoosePlan(false);
      fetchPayments();}} />}

    <Col sz="12" className="mt-3">
      <Card border="light" className="shadow dashboardStats h-100">
        <Card.Body className="py-0">
          <h3 className="p-0">Payment History</h3>
          {payments.length === 0 && <Alert variant="light" className="text-center p-3">No Payments found!</Alert>}
          {payments.length > 0 && <Table borderless>
            <thead>
              <tr>
                <th>Plan Name</th>
                <th>Purchase date</th>
                <th>Amount(GBP)</th>
                <th>Invoice</th>
              </tr>
            </thead>
            <tbody>
              {payments.map(renderPaymentRow)}
            </tbody>
          </Table>}
        </Card.Body>
      </Card>
    </Col>
  </Row>;
};

export default PlanHeader;